import { Avatar, Accordion, AccordionSummary, Typography, AccordionDetails, Container } from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import WorkIcon from '@mui/icons-material/Work';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './About.css'
import AddLocationIcon from '@mui/icons-material/AddLocation';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';


export default function About() {
  return (
    <div className='cont'>
      <div className='prof-cont'>
          <Avatar alt="profile img" src="/static/images/avatar/1.jpg" sx={{ width: 156, height: 156, margin: 'auto' }} />
          <List sx={{display: 'flex', flexDirection: 'column', width: '100%', bgcolor: 'background.paper' }}>
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <AccountCircleIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary="Age" secondary="22 Years Old" />
            </ListItem>
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <WorkIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary="Atual Work" secondary="After Sale Assistance" />
            </ListItem>
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <AddLocationIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary="Located" secondary="Lisbon, Portugal" />
            </ListItem>
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <EmojiEventsIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary="Career Goal" secondary="Full Stack Developer" />
            </ListItem>
          </List>
      </div>
      <div className='curri'>
        <Typography gutterBottom variant="h5" component="div">
          Curriculum
        </Typography>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>TRAINEE AT OBRILUZ COMPANY 3 Months</Typography>
          </AccordionSummary>
          <AccordionDetails>• Positioning of passage boxes and ducts;<br></br>
            • Installation of conductors inside the already positioned ducts;<br></br>
            • Assembly and installation of measurement and distribution tables;<br></br>
            • Installation of switches, sockets and luminaires;<br></br>
            • Measurement of the operation of all electrical points;<br></br>
            • Analysis and interpretation of technical drawings;<br></br>
            • Identification of circuits and know how to install correct wiring and equipment;<br></br>
            • Be able to perform repairs on damaged electrical appliances, and replace them in cases of total loss.<br></br>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>ELECTRICIAN'S HELPER ENAT- ENERGIAS NATURAIS 8 Months</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              • Installation of sanitary water heating systems and connection of thermoacumolators to the water
              network of the house;<br></br>
              • Installation of photovoltaic panels;<br></br>
              • Positioning of passage boxes and eltroducts;<br></br>
              • Installation of conductors within the already positioned ducts;<br></br>
              • Positioning of copper passage pipes for air conditioning units;<br></br>
              • Installation of copper pipes for air conditioning units already positioned;<br></br>
              • Power connection of both outdoor unit and indoor air conditioning;<br></br>
              • Fault-failure to do so in the air conditioning units
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>TEST AND REPAIR TECHNICIAN TRC 9 Months</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              • Monitoring of tests performed in boxes and routers;<br></br>
              • Assitence to test operators;<br></br>
              • Repair of electronic devices, used in testing, and organization of wiring;<br></br>
              • Troubleshooting both hardware and software;<br></br>
              • Error reporting.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>ELECTRONIC EQUIPMENT REPAIR TECHNICIAN TAMET 4 Months</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              • Reception of equipment sent by logistics;<br></br>
              • Identification and analysis of malfunctions;<br></br>
              • Equipment repair;<br></br>
              • Closure of the repair.<br></br>
              • Return of equipment to logistics.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>MECHANICAL MAINTENANCE TECHNICIAN SECO CENTRIFUGAÇÃO LDA 18 Months</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              • Perform lubrication and maintenance with great focus on machines that perform wastewater
              treatment;<br></br>
              • Diagnosis of anomalies:<br></br>
              • Preventive maintenance;<br></br>
              • Bearing replacement;<br></br>
              • Selection and organization of parts for replacement of joints, bearings, grease, motor belts;<br></br>
              • Connection of electric motors;<br></br>
              • Programming of speed variators;<br></br>
              • Programming centrifugal controllers.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>

    </div>

  )
}
